import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { ClientsRegistrationDataModel } from "../../../../model";
import { AsyncValidatorFn, FormControl, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "../../../../auth/auth.service";
import { debounceTime, distinctUntilChanged, first, map, of, switchMap } from "rxjs";
import { AppConfigService } from "../../../../app-config.service";

@Component({
    selector: "app-client-form",
    templateUrl: "./client-form.component.html",
    styleUrls: ["./client-form.component.scss"],
    standalone: false
})
export class ClientFormComponent implements OnInit, OnChanges {
    @Input() visible: boolean = false;
    @Input() clientData?: ClientsRegistrationDataModel | any;
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() dataChanged = new EventEmitter<ClientsRegistrationDataModel>();
    @Output() onHide = new EventEmitter<void>();

    registerForm!: FormGroup;
    editMode: boolean = false;
    cargoId!: number;

    constructor(private auth: AuthService, private config: AppConfigService) {
        this.cargoId = config.getConfig().cargoId;
    }

    ngOnInit(): void {
        this.registerForm = new FormGroup({
            'id': new FormControl(null),
            'client_id': new FormControl(null),
            'first_name': new FormControl(null, [Validators.required, Validators.minLength(2)]),
            'last_name': new FormControl(null, [Validators.required, Validators.minLength(2)]),
            'login': new FormControl(null, [Validators.required, Validators.minLength(3)], [this.loginExistValidatorFn()]),
            'phone': new FormControl(null, [Validators.required, Validators.minLength(10)]),
            'email': new FormControl(null, [Validators.required, Validators.email, Validators.minLength(6)], this.emailExistsValidatorFn()),
            'client_code': new FormControl(null, [Validators.required, Validators.minLength(3)], this.clientExistsValidatorFn()),
            'client_city': new FormControl(null, [Validators.required, Validators.minLength(3)])
        });

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.hasOwnProperty('clientData') && this.clientData) {
            this.editMode = this.clientData !== undefined;

            if (this.editMode) {
                this.registerForm.patchValue({ id: this.clientData.id, client_id: this.clientData.id,  });
                this.registerForm.patchValue(this.clientData);

                this.registerForm.controls['login'].markAsTouched();
                this.registerForm.controls['email'].markAsTouched();
                this.registerForm.controls['phone'].markAsTouched();
                this.registerForm.controls['client_code'].markAsTouched();
                this.registerForm.controls['client_city'].markAsTouched();

            }
        }

    }

    loginExistValidatorFn(): AsyncValidatorFn {
        return control => control.valueChanges
            .pipe(
                debounceTime(400),
                distinctUntilChanged(),
                map(() => this.editMode && this.clientData?.login === control.value), // check if vaulue changed
                switchMap(value => value ? of(null) : this.auth.isLoginExists(this.cargoId, control.value)), // request data from server
                map((exists: boolean) => (exists ? { loginAlreadyExist: true } : null)),
                first() // important to make observable finite
            );
    }

    emailExistsValidatorFn(): AsyncValidatorFn {
        return control => control.valueChanges
            .pipe(
                debounceTime(400),
                distinctUntilChanged(),
                map(() => this.editMode && this.clientData?.email === control.value), // check if vaulue changed
                switchMap(value => value ? of(null) : this.auth.isEmailExists(this.cargoId, control.value)), // request data from server
                map((exists: boolean) => (exists ? { emailAlreadyExist: true } : null)),
                first() // important to make observable finite
            );
    }

    clientExistsValidatorFn(): AsyncValidatorFn {
        return control => control.valueChanges
            .pipe(
                debounceTime(400),
                distinctUntilChanged(),
                map(() => this.editMode && this.clientData?.client_code === control.value), // check if vaulue changed
                switchMap(value => value ? of(null) : this.auth.isClientExists(this.cargoId, control.value)), // request data from server
                map((exists: boolean) => (exists ? { userAlreadyExist: true } : null)),
                first() // important to make observable finite
            );
    }

    saveClientForm() {
        if (this.registerForm.valid) {
            if (this.editMode) {
                const subscr = this.auth.updateClient(this.registerForm.value).subscribe({
                    next: (res) => {
                        if (res) {
                            alert("Данные клиента обновлены");
                            this.dataChanged.emit(this.registerForm.value);
                        } else {
                            alert("Данные клиента НЕ обновлены");
                        }
                    },
                    complete: () => {
                        subscr.unsubscribe();
                        this.closeDialog();
                    },
                    error: (err) => {
                        subscr.unsubscribe();
                        alert(err);
                    }
                });
            } else {
                alert('Данные НЕ обновлены');
                this.closeDialog();
            }
        }
    }

    closeDialog() {
        this.visibleChange.emit(false);
        this.onHide.emit();
    }

    checkIf(value: any) {
        debugger;  //open the devtools and go to the view...code execution will stop here!
        //..code to be checked... `value` can be inspected now along with all of the other component attributes
    }
}